import { toast } from 'react-toastify';

export function showToastMsg(message){
    toast.dark(message);
}